import useGetPassengerClassColor from "@CheckOrder/features/classPicker/hooks/useGetPassengerClassColor";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useColorCodeUsersInTheSamePassengerGroup(
    selectedPassengerClass: AvailablePassengerClassType,
    passengerId: number,
    isReturnLeg: boolean
) {
    const {
        isReturn: isReturnTicket,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const {color} = useGetPassengerClassColor(passengerId, isReturnLeg)

    if (selectedPassengerClass?.groupId && color) {
        if (isReturnLeg) {
            return {
                colorCodedClassName: "group-color-code-right",
                colorCodedStyle: {borderRight: `10px solid ${color}`},
            }
        }

        if (isReturnTicket) {
            return {
                colorCodedClassName: "group-color-code-left",
                colorCodedStyle: {borderLeft: `10px solid ${color}`},
            }
        }

        return {
            colorCodedClassName: "group-color-code-right",
            colorCodedStyle: {borderRight: `10px solid ${color}`},
        }
    }

    return {
        colorCodedClassName: "",
        colorCodedStyle: undefined,
    }
}